// Keep Umi's locale registry lightweight. Complete messages are loaded on demand
// from `localeBundles/en-US` during application startup.
export default {};
